function AntiFraudPolicy() {
  return (
    <main className="about" >
      {/* Own Story Section */}
      <section className="own_story">
        <div className="container">
          <div className="own_story_data">
            <div className="heading">
              <h2>Antifraud Policy</h2>
            </div>

            <div className="content">
              <h6 class="sub-heading"> Anti-Fraud Policy of Bajaj Capital Insurance Broking Limited
                (“BCIBL/Company”)</h6>

              <p>The Insurance Development and Regulatory Authority of India (IRDAI), vide its Guidelines on
                Insurance e-commerce bearing number IRDA/INT/GDL/ECM/055/03/2017 dated 9th March 2017
                mandates a pro-active fraud detection policy for the insurance e-commerce activities which
                is approved by the board of directors of the company.</p>

              <p>The Company has put in place the framework for identification and mitigation of frauds in the
                company (“Anti-Fraud Framework) to protect itself and the insurance sector from financial
                and reputational risks.</p>

              <p>The Anti-Fraud Framework is applicable on acts of fraud including suspected fraud in BCIBL
                which may involve employees (including contractual employees), shareholders, insurance
                companies, clients, vendors or any other party that has a business relationship with the
                Company.</p>

              <p>IRDAI’s circular bearing IRDAI/SDD/MISC/CIR/009/01/2013 describes fraud in insurance as an
                act or omission intended to gain dishonest or unlawful advantage for a party committing the
                fraud or for other related parties. This may, for example, be achieved by means of:</p>

              <p>misappropriating assets;</p>

              <p>deliberately misrepresenting, concealing, suppressing or not disclosing one or more material
                facts relevant to the financial decision, transaction or perception of the insurer’s status;
              </p>

              <p>abusing responsibility, a position of trust or a fiduciary relationship</p>

              <p> BCIBL’s Antti-Fraud Framework includes identifying, managing, monitoring and prevention of
                fraud risks.</p>

              <p> The Company regularly monitors activities for identification of fraud risk through its risk
                assessment process and adopts a pro-active approach for prevention of risks which involves
                implementing effective controls for prevention of frauds before they occur.</p>

              <p> In the Company, cases of fraud are reported internally, investigated and appropriate
                disciplinary action is taken. The Compliance team is actively involved in the process and
                the Internal Audit team independently assesses the effectiveness of the Anti-Fraud Framework
                and is also responsible for reporting to the Board of Directors of the Company.</p>

              <p> Employees are regularly given trainings covering Anti Money Laundering, Anti-Bribery and
                Corruption etc. Awareness amongst employees is also created through regular circulars,
                communication by the leaders via e-mail and at townhalls/meetings etc.</p>
            </div>
          </div>
        </div>
      </section>
      {/* End of Own Story Section */}
    </main>
  );
}

export default AntiFraudPolicy;
